// ============================================================================
// TRANSLATIONS
// ============================================================================

export const TRANSLATIONS = {
  de: {
    // Authentication
    login: "Anmelden",
    logout: "Abmelden",
    email: "E-Mail",
    password: "Passwort",
    emailPlaceholder: "ihre.email@beispiel.ch",
    passwordPlaceholder: "Passwort eingeben",
    forgotPassword: "Passwort vergessen?",
    loginError: "Login fehlgeschlagen",

    // Navigation
    dashboard: "Dashboard",
    tasks: "Aufgaben",
    templates: "Vorlagen",
    users: "Benutzer",
    analytics: "Auswertungen",
    settings: "Einstellungen",

    // Dashboard
    welcomeBack: "Willkommen zurück",
    taskOverview: "Aufgaben-Übersicht",
    openTasks: "Offene Aufgaben",
    completedTasks: "Erledigte Aufgaben",
    overdueTasks: "Überfällige Aufgaben",
    futureTasks: "Zukünftige Aufgaben",
    recentActivity: "Letzte Aktivitäten",
    quickActions: "Schnellaktionen",

    // Tasks
    createTask: "Aufgabe erstellen",
    newTask: "Neue Aufgabe",
    title: "Titel",
    description: "Beschreibung",
    assignee: "Zuständig",
    dueDate: "Fälligkeitsdatum",
    priority: "Priorität",
    location: "Standort",
    status: "Status",
    actions: "Aktionen",

    // Analytics / Stats
    totalCompleted: "Gesamt erledigt",
    percentDelayed: "Verspätet",
    percentOnTime: "Pünktlich",
    percentWithIssues: "Mit Problemen",
    noDataForFilters: "Keine Daten für die gewählten Filter",

    // Date Range Filter
    dateRange: "Zeitraum",
    startDate: "Von",
    endDate: "Bis",
    last30Days: "Letzte 30 Tage",
    last90Days: "Letzte 90 Tage",
    customRange: "Benutzerdefiniert",

    // Filters
    filterByUser: "Nach Benutzer filtern",
    filterByLocation: "Nach Standort filtern",
    filterByStatus: "Nach Status filtern (nur Aufgabenliste)",
    allUsers: "Alle Benutzer",
    allLocations: "Alle Standorte",

    // Users
    name: "Name",
    role: "Rolle",
    admin: "Admin",
    user: "Benutzer",
    active: "Aktiv",
    inactive: "Inaktiv",

    // Common
    save: "Speichern",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    delete: "Löschen",
    complete: "Erledigen",
    loading: "Lädt...",
    noTasksFound: "Keine Aufgaben gefunden",
    error: "Fehler"
  },
  en: {
    // Authentication
    login: "Login",
    logout: "Logout",
    email: "Email",
    password: "Password",
    emailPlaceholder: "your.email@example.com",
    passwordPlaceholder: "Enter password",
    forgotPassword: "Forgot password?",
    loginError: "Login failed",

    // Navigation
    dashboard: "Dashboard",
    tasks: "Tasks",
    templates: "Templates",
    users: "Users",
    analytics: "Analytics",
    settings: "Settings",

    // Dashboard
    welcomeBack: "Welcome back",
    taskOverview: "Task Overview",
    openTasks: "Open Tasks",
    completedTasks: "Completed Tasks",
    overdueTasks: "Overdue Tasks",
    futureTasks: "Future Tasks",
    recentActivity: "Recent Activity",
    quickActions: "Quick Actions",

    // Tasks
    createTask: "Create Task",
    newTask: "New Task",
    title: "Title",
    description: "Description",
    assignee: "Assignee",
    dueDate: "Due Date",
    priority: "Priority",
    location: "Location",
    status: "Status",
    actions: "Actions",

    // Analytics / Stats
    totalCompleted: "Total Completed",
    percentDelayed: "Delayed",
    percentOnTime: "On Time",
    percentWithIssues: "With Issues",
    noDataForFilters: "No data for selected filters",

    // Date Range Filter
    dateRange: "Date Range",
    startDate: "From",
    endDate: "To",
    last30Days: "Last 30 Days",
    last90Days: "Last 90 Days",
    customRange: "Custom Range",

    // Filters
    filterByUser: "Filter by User",
    filterByLocation: "Filter by Location",
    filterByStatus: "Filter by Status (tasks only)",
    allUsers: "All Users",
    allLocations: "All Locations",

    // Users
    name: "Name",
    role: "Role",
    admin: "Admin",
    user: "User",
    active: "Active",
    inactive: "Inactive",

    // Common
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    complete: "Complete",
    loading: "Loading...",
    noTasksFound: "No tasks found",
    error: "Error"
  }
};
